import { EnumPriceListType } from './Generated';
import type { SelectOption } from '@synqo/frontend-component-library';

export function getPriceListTypeName(type: EnumPriceListType) {
    switch (type) {
        case EnumPriceListType.Base:
            return 'Grundpreisliste';
        case EnumPriceListType.Customer:
            return 'Kundenpreisliste';
        case EnumPriceListType.Site:
            return 'Anschriftenpreisliste';
        default:
            return 'Unbekannt';
    }
}

export const priceListOptions: SelectOption<EnumPriceListType>[] = [
    { name: 'base', label: getPriceListTypeName(EnumPriceListType.Base), value: EnumPriceListType.Base },
    { name: 'customer', label: getPriceListTypeName(EnumPriceListType.Customer), value: EnumPriceListType.Customer },
    { name: 'site', label: getPriceListTypeName(EnumPriceListType.Site), value: EnumPriceListType.Site },
];
